import React, { useState } from "react";
import { MuiChipsInput } from 'mui-chips-input'
import { Button, Input } from "@mantine/core";

import "./scriptExecutor.css";
import { themeProvider } from "../../../../../style/utils";
import { queryExecutorInput, scriptExecutorRequestBody, scriptExecutorResponse, ScriptExecutorProps } from "../../../../../../types/types";
import { useAuth } from "../../../../../../providers/AuthProvider";
import { executeScript } from "../../../../../../services/executorService";

const ScriptExecutor = (props: ScriptExecutorProps) => {
    const [loginInput, setloginInput] = useState<queryExecutorInput>({});
    const [scriptResponse, setScriptResponse] = useState<scriptExecutorResponse>();
    const [errorResponse, setErrorResponse] = useState<any>();
    const authContext = useAuth();

    const getScriptExecutionBody:()=>scriptExecutorRequestBody = () => {
        const reqBody:scriptExecutorRequestBody = {
            "configuration": props.configuration,
            "executionMode": props.executionMode,
            "statusEvaluator": props.script
        };
        props.executionMode === "BATCH" && (reqBody.loginIds = loginInput.loginIds);
        props.executionMode === "SPLIT" && (reqBody.loginId = loginInput.loginId);
        return reqBody;
    }

    const runScript = async() => {
        const scriptExecutionBody = getScriptExecutionBody();
        try{
            const response = await executeScript(scriptExecutionBody,authContext)
            setScriptResponse(response);
        }
        catch(e) {
            setErrorResponse(e);
        }
    }

    const openRunSqlDisplay = () => {
        props.setScriptEditorOpened(true);
        props.setScriptExecutorOpened(false);
    }

    const updateLoginInput = (event: {
        target: { value: string };
    }) => {
        const inputData: any = {};
        inputData.loginId = event.target.value.trim();
        setloginInput(inputData);
    };

    const [chips, setChips] = React.useState<string[]>([])
    const handleChange = (newChips: string[]) => {
        setChips(newChips);
        setloginInput({ ...loginInput, loginIds: newChips })
    }

    const getStringifiedResponse = ()=>{
        return JSON.stringify(scriptResponse,undefined,2);
    }
    const getStringifiedErrorResponse = ()=>{
        return JSON.stringify(errorResponse,undefined,2);
    }


    return (
        <div>
            <div className="scriptExecutor-heading"> Script Executor </div>
            <div className="scriptExecutor-container">
                {props.executionMode === "SPLIT" && <Input
                    className="scriptExecutor-input"
                    placeholder="Enter Login Id"
                    onChange={updateLoginInput}
                />}
                {props.executionMode === "BATCH" && <MuiChipsInput
                    value={chips}
                    onChange={handleChange}
                    label="Enter Login Ids"
                    onPointerEnterCapture={() => {}}
                    onPointerLeaveCapture={() => {}}
                />}
                <div className="scriptExecutor-output">
                    {scriptResponse && <pre>{getStringifiedResponse()}</pre>}
                    {errorResponse && <pre>{getStringifiedErrorResponse()}</pre>}
                </div>
            <div className="scriptExecutor-buttonContainer">
                    <Button sx={themeProvider} color="teal" variant="outline" onClick={runScript} style={{marginRight: "70px"}}>
                        Test
                    </Button>
                    <Button sx={themeProvider} color="teal" variant="outline" onClick={openRunSqlDisplay}>
                        Edit Script
                    </Button>
            </div>
            </div>
        </div>
    );
};

export default ScriptExecutor;
